import { render, staticRenderFns } from "./ProjectWorkItems.vue?vue&type=template&id=377cffad&scoped=true"
import script from "./ProjectWorkItems.vue?vue&type=script&lang=js"
export * from "./ProjectWorkItems.vue?vue&type=script&lang=js"
import style0 from "./ProjectWorkItems.vue?vue&type=style&index=0&id=377cffad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377cffad",
  null
  
)

export default component.exports